// extracted by mini-css-extract-plugin
export default {"wrapper":"BankButton_wrapper__lA-BG"};